import React from "react";
import { createRoot } from "react-dom/client";
import "./i18n"; // OVO MORA BITI OVDJE
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);